<template>
  <tr>
    <td class="align-middle">
      <div>
        <small>
          {{ dayMonth(order.created_at) }}

          <small class="text-muted">
            {{ minuteHour(order.created_at) }}
          </small>
        </small>
      </div>
    </td>
    <td class="align-middle">
      <div>
        <small>
          {{ order.first_name }} {{ order.last_name }}
        </small>
      </div>
      <div>
        <small>
          <small>
            {{ order.phone_number }},
            {{ order.personal_number }}
          </small>
        </small>
      </div>
    </td>
    <td class="align-middle">
      <small v-if="address">
        {{ address.city }}, {{ address.postal_code }}
      </small>
    </td>
    <td class="align-middle td-company">
      <img :src="order.contract.company.logo" v-if="order.contract.company.logo" class="mr-2">
    </td>
    <td class="align-middle td-company">
      <small class="text-muted">
        {{ order.contract.company.name }}
      </small>
    </td>
    <td class="align-middle">
      <small>
        {{ order.contract.year_price }}kr
      </small>
    </td>
    <td class="align-middle">
      <small>
        {{ order.search.power_consumption }}kWh
      </small>
    </td>
  </tr>
</template>

<script>

  import DateMixin from "./../../../../app/mixins/helpers/DateMixin"

  export default {
    name: "OrderItem",
    mixins: [DateMixin],
    props: {
      order: {
        format: Object,
        required: true
      }
    },
    computed: {
      address(){
        return this.order.addresses.find(address => address.type === 'facility')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Dashboard/Orders/Partials/OrderItem.vue